import { tateConfig, yokoConfig } from './sheet.config'

export const S6_CW2503_TestA_2111123 = {
  FRONT: {
    EXAM_GROUP_KEY: '02624003111',
    QR_INFO: {
      checkDigit: 6315,
      correctSize: tateConfig.correctedSize,
      correctMarkers: tateConfig.correctedMarkers,
      asGray: false,
      disableWhitebarance: true,
      rotateQrPos: tateConfig.correctedRotateQrPos,
      numCheckPosition: {
        ...tateConfig.correctedNumCheckArea,
        l: tateConfig.correctedNumCheckArea.l - 2
      },
      clipScale: 0.8,
      isHorizontal: false
    }
  },
  REVERSE: {
    EXAM_GROUP_KEY: '02624003122',
    QR_INFO: {
      checkDigit: 6320,
      correctSize: yokoConfig.correctedSize,
      correctMarkers: yokoConfig.correctedMarkers,
      asGray: false,
      disableWhitebarance: true,
      rotateQrPos: yokoConfig.correctedRotateQrPos,
      numCheckPosition: {
        ...yokoConfig.correctedNumCheckArea,
        l: yokoConfig.correctedNumCheckArea.l - 5
      },
      clipScale: 1.0,
      isHorizontal: true
    }
  }
} as const
